module.exports = __webpack_public_path__ + "img/grid-topology.bd75854d.webp";